import { createSelector } from '@reduxjs/toolkit';

import { RootSelector, getStore } from '../../models/rootSelector';
import { NodeFlag } from '../../../general/model';
import { getSelectedRowsInCurrentFolder } from '../fileManager/selectors/selectors';
import { getBreadcrumbs } from '../breadcrumbs/selectors';
import { CreativeConverterJob, CreativeConverterShape } from './model';
import { CHNodeIsFolder } from '../../../general/node';

export const getIsAvailable: RootSelector<boolean> = createSelector(
  [getSelectedRowsInCurrentFolder, getBreadcrumbs],
  (selectedRows, breadcrumbs) => {
    const allFolders = selectedRows.every((row) => {
      return (
        !row.flags.includes(NodeFlag.folder_creative) &&
        CHNodeIsFolder(row) &&
        row.conversionState?.errors.find((error) =>
          //мне важно было запрещать конвертацию при _конкретной_ ошибке, а не любой ошибке
          //если запрещать конвертацию при любой ошибке, то ломается MYUA-2607
          //TODO: Учесть, что ошибка может быть переведена на бэке на другие языки
          error.startsWith('Not allowed file formats'),
        ) === undefined
      );
    });
    const currentNodeEligibleForConversion =
      breadcrumbs.some((b) => b.flags.includes(NodeFlag.folder_project)) &&
      breadcrumbs.some((b) => b.flags.includes(NodeFlag.folder_creative_type));

    return allFolders && selectedRows.length > 0 && currentNodeEligibleForConversion;
  },
);

export const getConverter: RootSelector<CreativeConverterShape> = createSelector(
  getStore,
  (x) => x.creativeConverter,
);

export const getJobs = createSelector([getConverter], (x) => x.jobs);
export const getReadyPrompt = createSelector([getConverter], (x) => x.readyPrompt);
export const getNextJob: RootSelector<CreativeConverterJob | undefined> = createSelector(
  [getJobs],
  (jobs) => jobs.find((job) => !job.finished && job.error === ''),
);

export const getCache = createSelector([getConverter], (x) => x.cache);
